import { getApplicationBeneList } from '../Application/actions';
import { fetchQueryData } from '../../../utils/sf-request';

export function getBeneficiaryCount(siteToken, accountId, publicKey) {
    const query = `Select Id, Contact_Name__r.Active__c FROM Person__c WHERE Contact_Name__c <> null and Application__r.Related_Account__c = '${accountId}'  and RecordType.Name = 'Beneficiary'`;
    return fetchQueryData(query, siteToken.hash, publicKey);
}

export function getApplicationsCount(siteToken, accountId, publicKey) {
    const query = `SELECT Application__r.Name  FROM Person__c WHERE  Application__r.Related_Account__c='${accountId}' and RecordType.Name = 'Beneficiary'`;
    return fetchQueryData(query, siteToken.hash, publicKey);
}

export async function getTotalFund() {
    const { user } = this.props;
    const data = await getApplicationBeneList(user.loggedInUser.Account.Id, user.siteToken.hash, user.key);
    let beneIds = '';
    for (let i = 0; i < data.records.length; i++) {
        beneIds += `'${data.records[i].Id}',`;
    }
    beneIds = beneIds.substring(0, beneIds.length - 1);
    // fetching the receipt data
    const query = `Select Approved_Amount__c from Receipt__c WHERE Generated_From__c IN (${beneIds}) Order By Status__c, Scheduled_Payout_Date__c`;
    return fetchQueryData(query, user.siteToken.hash, user.key);
}


export default null;



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/DashBoard/actions.js
// module id = 990
// module chunks = 0